export default __webpack_public_path__ + "locales/si/MainBar.json?hash=7070225e2cc255032456e2e65351d35d";